/**
 * @file ChallengeActions — the action buttons under the game.
 *
 * "Play / Play Fullscreen" is a local action wired to the Unity player.
 * "Previous Challenges" navigates to the archive. "Leaderboard" is only shown
 * for the live (current) week — archived weeks have no leaderboard.
 */

import { Link } from 'react-router-dom';
import { routes } from '../config/scrWeeklyConfig';

/**
 * @param {{
 *   started?: boolean,
 *   archived?: boolean,
 *   onPlayFullscreen?: () => void
 * }} props
 */
export function ChallengeActions({
  started = false,
  archived = false,
  onPlayFullscreen,
}) {
  return (
    <div className="scrw-challenge__actions">
      <button
        type="button"
        className="scrw-btn scrw-btn--primary scrw-btn--lg"
        onClick={onPlayFullscreen}
      >
        {started ? '⛶ Play Fullscreen' : '▶ Play'}
      </button>

      <Link className="scrw-btn scrw-btn--ghost scrw-btn--lg" to={routes.archive}>
        Previous Challenges
      </Link>

      {/* No leaderboard for archived weeks. */}
      {!archived ? (
        <Link
          className="scrw-btn scrw-btn--ghost scrw-btn--lg"
          to={routes.leaderboard}
        >
          Leaderboard
        </Link>
      ) : null}
    </div>
  );
}
